<template>
  <h3 class="font-semibold text-gray-700 text-xl">Aceptado - Descarte</h3>
  <div class="flex justify-around my-4 pr-16">
    <div class="space-x-4 items-center">
      <div>
        <p class="text-sm font-medium uppercase leading-4">Aceptado (Kg)</p>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          {{ numberWithPrecision(total_ok) }}
        </p>
      </div>
    </div>
    <div class="space-x-4 items-center">
      <div>
        <p class="text-sm font-medium uppercase leading-4">Descarte (Kg)</p>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          {{ numberWithPrecision(total_discard) }}
        </p>
      </div>
    </div>
  </div>
  <div id="chart5">
    <apexchart
      type="bar"
      :height="height"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessShowReportsGraphicsOkDiscardMonthly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    height: { default: 350 },
    summary: { required: true }
  },
  data() {
    return {
      series: [
        {
          name: "Aceptado",
          data: this.data.ok
        },
        {
          name: "Descarte",
          data: this.data.discard
        }
      ],
      options: {
        chart: {
          type: "bar",
          height: this.height,
          stacked: true,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            columnWidth: this.barWidth(),
            dataLabels: {
              total: {
                enabled: false,
                style: { fontSize: "13px" }
              }
            }
          }
        },
        dataLabels: {
          formatter: function (val, { globals, dataPointIndex }) {
            const percent =
              (val /
                (globals.series[0][dataPointIndex] +
                  globals.series[1][dataPointIndex])) *
              100;
            return this.numberWithPrecision(percent, 1) + "%";
          }.bind(this),
          style: { fontSize: "14px" },
          dropShadow: { enabled: true }
        },
        xaxis: {
          categories: this.data.categories
        },
        yaxis: {
          title: { text: "Kilogramos" },
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val, 0);
            }.bind(this)
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        colors: ["#65A30D", "#CC3333"]
      }
    };
  },
  computed: {
    total_ok() {
      return this.summary?.ok_weight;
    },

    total_discard() {
      return this.summary?.discarded_weight;
    }
  },
  methods: {
    barWidth() {
      if (this.data.categories.length < 3) return "20%";
      if (this.data.categories.length < 6) return "50%";
      return "70%";
    }
  }
};
</script>
